import { useState, useEffect, useCallback } from 'react';
import { X, ArrowRight } from 'lucide-react';

export default function ExitIntentPopup() {
  const [visible, setVisible] = useState(false);

  const showPopup = useCallback(() => {
    const dismissed = sessionStorage.getItem('exit_popup_dismissed');
    if (dismissed) return;
    setVisible(true);
  }, []);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 5 && e.relatedTarget === null) {
        showPopup();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 5000);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [showPopup]);

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem('exit_popup_dismissed', '1');
  };

  const goToCalendly = () => {
    dismiss();
    window.open('https://calendly.com/chr-globalcitizen/video-consultation-clone', '_blank');
  };

  if (!visible) return null;

  return (
    <div
      data-testid="exit-intent-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={dismiss}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      <div
        data-testid="exit-intent-modal"
        className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={dismiss}
          data-testid="exit-intent-close"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="text-center">
          <h3
            className="text-2xl font-semibold text-[#1a1a1a] mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Before you go.
          </h3>
          <p
            className="text-gray-500 text-sm leading-relaxed mb-6"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            If your jurisdictional position deserves a second look, we are available by introduction. Initial conversations are confidential and without obligation.
          </p>
          <button
            onClick={goToCalendly}
            data-testid="exit-intent-cta"
            className="bg-[#1a7a7a] text-white font-bold py-3.5 px-8 rounded-lg hover:bg-[#1a6868] transition-all text-sm inline-flex items-center gap-2"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Request an Introduction
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
